import { Type } from "../../../../.remote/gatsby-imgly-source/3da22cbf2aac60efa607bb2de361c0530787fd65/web/docs/PESDK/docs/shared/components/Type";
import * as React from 'react';
export default {
  Type,
  React
};